
import { supabase } from '@/integrations/supabase/client';

export const checkBrokerByReferralCode = async (referralCode: string) => {
  try {
    const cleanReferralCode = referralCode.trim();
    console.log("Looking up broker with referral code:", cleanReferralCode);
    
    // First approach: Direct exact match query
    const { data: exactData, error: exactError } = await supabase
      .from('broker_profiles')
      .select('id, company_name, referral_code, description')
      .eq('referral_code', cleanReferralCode);
      
    console.log("Exact search results:", exactData);
    
    if (!exactError && exactData && exactData.length > 0) {
      console.log("Broker found with exact match:", exactData[0]);
      return {
        exists: true,
        id: exactData[0].id,
        companyName: exactData[0].company_name,
        description: exactData[0].description,
        referralCode: exactData[0].referral_code
      };
    }
    
    // Second approach: Case-insensitive search
    const { data, error } = await supabase
      .from('broker_profiles')
      .select('id, company_name, referral_code, description')
      .ilike('referral_code', cleanReferralCode);
    
    console.log("Case-insensitive search results:", data);
    
    if (error) {
      console.error('Error checking broker:', error);
      return null;
    }

    // If we found data, find exact match ignoring case
    if (data && data.length > 0) {
      console.log("Found broker profiles with similar codes:", data);
      
      // Find exact match ignoring case
      const matchingBroker = data.find(broker => 
        broker.referral_code.toLowerCase() === cleanReferralCode.toLowerCase()
      );
      
      if (matchingBroker) {
        console.log("Broker found with case-insensitive match:", matchingBroker);
        return {
          exists: true,
          id: matchingBroker.id,
          companyName: matchingBroker.company_name,
          description: matchingBroker.description,
          referralCode: matchingBroker.referral_code
        };
      }
    }
    
    // Third approach: Use the database function we created
    console.log("Trying database function approach...");
    
    const { data: functionData, error: functionError } = await supabase
      .rpc('find_broker_by_referral_code', { code: cleanReferralCode });
    
    console.log("Database function results:", functionData);
    
    if (!functionError && functionData && functionData.length > 0) {
      const broker = functionData[0];
      return {
        exists: true,
        id: broker.id,
        companyName: broker.company_name,
        description: broker.description,
        referralCode: broker.referral_code
      };
    }
    
    // Debug log all available broker codes to help troubleshoot
    const { data: allBrokers } = await supabase
      .from('broker_profiles')
      .select('id, referral_code, company_name');
      
    console.log("All available broker profiles:", allBrokers?.map(b => ({
      id: b.id,
      code: b.referral_code,
      company: b.company_name
    })));
    
    return null;
  } catch (error) {
    console.error('Unexpected error:', error);
    return null;
  }
};

// Debug function to check broker existence
export const debugCheckBrokerExistence = async (referralCode: string) => {
  console.log("DEBUG: Checking broker existence for code:", referralCode);
  const result = await checkBrokerByReferralCode(referralCode);
  console.log('DEBUG Broker Existence Check:', result);
  return result;
};
